import {
  ExpandedRowKeysProvider,
  TableRowSelectionProvider,
} from '@/components';
import { ProjectPageActiveTabProvider } from '@/providers';
import type { FC, PropsWithChildren } from 'react';
import { ReactFlowProvider } from 'reactflow';
import { NestedTablePaginationProvider } from '../../_components/NestedTablePaginationProvider';
import { TableSorterProvider } from '../../_components/ProjectTableSorterProvider';

export const ProjectsProvider: FC<PropsWithChildren> = ({ children }) => (
  <NestedTablePaginationProvider>
    <TableSorterProvider>
      <TableRowSelectionProvider>
        <ExpandedRowKeysProvider>
          <ReactFlowProvider>
            <ProjectPageActiveTabProvider>
              {children}
            </ProjectPageActiveTabProvider>
          </ReactFlowProvider>
        </ExpandedRowKeysProvider>
      </TableRowSelectionProvider>
    </TableSorterProvider>
  </NestedTablePaginationProvider>
);
